// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "Poppins", sans-serif;
}

.form-container {
    width: 40%;
    margin: 100px auto;
    padding: 20px;
    background-color: rgba(255, 255, 255, 0.95);
    border-radius: 20px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    position: relative;
    
    
}

@media only screen and (max-width: 600px) {
    .form-container {
        width: 90%;
        margin: 50px auto;
    }
}

.form-container h2 {
    text-align: center;
    color: #0e2431;
    margin-bottom: 20px;
}

.form-container form {
    display: flex;
    flex-direction: column;
}

.form-container label {
    margin-bottom: 10px;
    font-size: 1rem;
    color: #0e2431;
}

input[type="text"],
input[type="date"],
select {
    width: 100%;
    padding: 12px;
    margin-bottom: 15px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 1rem;
}

input[type="text"]:focus,
input[type="date"]:focus,
select:focus {
    outline: none;
    border-color: #0e2431;
    box-shadow: 0 0 3px rgba(14, 36, 49, 0.5);
}
/* Button container to align buttons to the right */
.button2-container {
    display: flex;
    justify-content: space-between; /* Align items to the right */
    margin-bottom: 20px; /* Add margin to separate from other content */
  }
.update-button {
    background-color: #418ff3;
    color: #fff;
    border: none;
    border-radius: 4px;
    padding: 10px;
    font-size: 1rem;
    cursor: pointer;
    
    transition: background-color 0.3s ease;
}
.update-button:hover {
    background-color: #3778cc;
}
.delete-button {
    background-color: #dc3545; /* Red background color */
    color: #fff;
    border: none;
    border-radius: 4px;
    padding: 10px;
    font-size: 1rem;
    cursor: pointer;
    
    transition: background-color 0.3s ease;
}

.delete-button:hover {
    background-color: #c82333; /* Darker red background color on hover */
}



.error-message {
    background-color: #f8d7da;
    color: red;
    margin-bottom: 10px;
    text-align: center;
}
#rackNumber:disabled {
    opacity: 1; /* Ensures it's fully visible */
    cursor: default; /* Keeps the default cursor */
    color: inherit; /* Inherits color from parent */
    background-color: white; /* Inherits background color from parent */
    
    appearance: none; /* Removes default styling */
  }
  .update-button:disabled {
    background-color: #6c757d; /* Gray color for disabled state */
    color: #ffffff; /* Text color for disabled state */
    cursor: not-allowed; /* Change cursor to indicate disabled state */
    opacity: 0.65; /* Optional: Make the button slightly transparent */
  }
  /* Overlay that covers the entire viewport and blocks interactions */
.overlay {
    position: fixed;          /* Fixed position to cover the entire viewport */
    top: 0;                  /* Top edge of the viewport */
    left: 0;                 /* Left edge of the viewport */
    width: 100vw;            /* Full viewport width */
    height: 100vh;           /* Full viewport height */
    background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent black */
    z-index: 1000;           /* High z-index to appear on top */
}

/* Popup container styles */
.confirmation-container {
    position: fixed;          /* Fixed position to center the popup */
    top: 50%;                 /* Center vertically */
    left: 50%;                /* Center horizontally */
    transform: translate(-50%, -50%); /* Adjust for exact center positioning */
    background-color: white; /* White background for the popup */
    color: black;            /* Black text color for contrast */
    padding: 20px;           /* Padding inside the popup */
    padding-bottom: 50px;
    border-radius: 8px;      /* Rounded corners for the popup */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); /* Shadow for better visibility */
    z-index: 1001;           /* Ensures the popup appears above the overlay */
    max-width: 500px;        /* Maximum width for the popup */
    width: 100%;             /* Full width up to the max-width */
    box-sizing: border-box; /* Include padding and border in the element's total width and height */
    text-align: center;      /* Center text inside the popup */
    display: flex;           /* Flexbox layout for aligning buttons vertically */
    flex-direction: column;  /* Stack buttons vertically */
    align-items: center;     /* Center buttons horizontally */
}

/* Styles for the text and buttons inside the popup */
.confirmation-container p {
    margin-bottom: 10px;     /* Space between text and buttons */
    white-space: pre-line;   /* Handle line breaks in text */
}

/* General button styles */
.download-link, .delete-button {
    margin: 5px;             /* Space between buttons */
    padding: 10px 20px;      /* Padding inside buttons */
    border: none;            /* Remove default border */
    border-radius: 4px;      /* Rounded corners for buttons */
    color: white;            /* Text color for buttons */
    cursor: pointer;         /* Pointer cursor on hover */
    font-size: 16px;         /* Font size for button text */
    width: 200px;            /* Defined width for buttons */
    
}

/* Specific button styles */
.download-link {
    background-color: #28a745; /* Green background color */
}

.download-link:hover {
    background-color: #218838; /* Darker green background color on hover */
}

.delete-button {
    background-color: #dc3545; /* Red background color */
    
}

.delete-button:hover {
    background-color: #c82333; /* Darker red background color on hover */
   
}

.cancel1-button {
    background-color: #007bff; /* Blue background color */
}

.cancel1-button:hover {
    background-color: #0056b3; /* Darker blue background color on hover */
}

/* Position cancel button in the right bottom corner */
.confirmation-container .cancel1-button {
    padding: 10px 20px;      /* Padding inside buttons */
    border: none;            /* Remove default border */
    border-radius: 4px;      /* Rounded corners for buttons */
    color: white;            /* Text color for buttons */
    cursor: pointer;         /* Pointer cursor on hover */
    font-size: 16px;       
margin-top: 5px;
width: 100px; 
  position:absolute;
  bottom: 10px;
  right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/styles/editRack.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,2CAA2C;IAC3C,mBAAmB;IACnB,uCAAuC;IACvC,kBAAkB;;;AAGtB;;AAEA;IACI;QACI,UAAU;QACV,iBAAiB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;;;IAGI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;;IAGI,aAAa;IACb,qBAAqB;IACrB,yCAAyC;AAC7C;AACA,mDAAmD;AACnD;IACI,aAAa;IACb,8BAA8B,EAAE,6BAA6B;IAC7D,mBAAmB,EAAE,8CAA8C;EACrE;AACF;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,eAAe;;IAEf,sCAAsC;AAC1C;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB,EAAE,yBAAyB;IACpD,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,eAAe;;IAEf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB,EAAE,yCAAyC;AACxE;;;;AAIA;IACI,yBAAyB;IACzB,UAAU;IACV,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,UAAU,EAAE,+BAA+B;IAC3C,eAAe,EAAE,6BAA6B;IAC9C,cAAc,EAAE,+BAA+B;IAC/C,uBAAuB,EAAE,0CAA0C;;IAEnE,gBAAgB,EAAE,4BAA4B;EAChD;EACA;IACE,yBAAyB,EAAE,kCAAkC;IAC7D,cAAc,EAAE,kCAAkC;IAClD,mBAAmB,EAAE,6CAA6C;IAClE,aAAa,EAAE,mDAAmD;EACpE;EACA,oEAAoE;AACtE;IACI,eAAe,WAAW,gDAAgD;IAC1E,MAAM,mBAAmB,6BAA6B;IACtD,OAAO,kBAAkB,8BAA8B;IACvD,YAAY,aAAa,wBAAwB;IACjD,aAAa,YAAY,yBAAyB;IAClD,oCAAoC,EAAE,2BAA2B;IACjE,aAAa,YAAY,kCAAkC;AAC/D;;AAEA,2BAA2B;AAC3B;IACI,eAAe,WAAW,uCAAuC;IACjE,QAAQ,kBAAkB,sBAAsB;IAChD,SAAS,iBAAiB,wBAAwB;IAClD,gCAAgC,EAAE,wCAAwC;IAC1E,uBAAuB,EAAE,mCAAmC;IAC5D,YAAY,aAAa,kCAAkC;IAC3D,aAAa,YAAY,6BAA6B;IACtD,oBAAoB;IACpB,kBAAkB,OAAO,kCAAkC;IAC3D,wCAAwC,EAAE,iCAAiC;IAC3E,aAAa,YAAY,gDAAgD;IACzE,gBAAgB,SAAS,gCAAgC;IACzD,WAAW,cAAc,mCAAmC;IAC5D,sBAAsB,EAAE,uEAAuE;IAC/F,kBAAkB,OAAO,iCAAiC;IAC1D,aAAa,YAAY,mDAAmD;IAC5E,sBAAsB,GAAG,6BAA6B;IACtD,mBAAmB,MAAM,gCAAgC;AAC7D;;AAEA,qDAAqD;AACrD;IACI,mBAAmB,MAAM,mCAAmC;IAC5D,qBAAqB,IAAI,+BAA+B;AAC5D;;AAEA,0BAA0B;AAC1B;IACI,WAAW,cAAc,0BAA0B;IACnD,kBAAkB,OAAO,2BAA2B;IACpD,YAAY,aAAa,0BAA0B;IACnD,kBAAkB,OAAO,gCAAgC;IACzD,YAAY,aAAa,2BAA2B;IACpD,eAAe,UAAU,4BAA4B;IACrD,eAAe,UAAU,8BAA8B;IACvD,YAAY,aAAa,8BAA8B;;AAE3D;;AAEA,2BAA2B;AAC3B;IACI,yBAAyB,EAAE,2BAA2B;AAC1D;;AAEA;IACI,yBAAyB,EAAE,2CAA2C;AAC1E;;AAEA;IACI,yBAAyB,EAAE,yBAAyB;;AAExD;;AAEA;IACI,yBAAyB,EAAE,yCAAyC;;AAExE;;AAEA;IACI,yBAAyB,EAAE,0BAA0B;AACzD;;AAEA;IACI,yBAAyB,EAAE,0CAA0C;AACzE;;AAEA,sDAAsD;AACtD;IACI,kBAAkB,OAAO,2BAA2B;IACpD,YAAY,aAAa,0BAA0B;IACnD,kBAAkB,OAAO,gCAAgC;IACzD,YAAY,aAAa,2BAA2B;IACpD,eAAe,UAAU,4BAA4B;IACrD,eAAe;AACnB,eAAe;AACf,YAAY;EACV,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: \"Poppins\", sans-serif;\n}\n\n.form-container {\n    width: 40%;\n    margin: 100px auto;\n    padding: 20px;\n    background-color: rgba(255, 255, 255, 0.95);\n    border-radius: 20px;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);\n    position: relative;\n    \n    \n}\n\n@media only screen and (max-width: 600px) {\n    .form-container {\n        width: 90%;\n        margin: 50px auto;\n    }\n}\n\n.form-container h2 {\n    text-align: center;\n    color: #0e2431;\n    margin-bottom: 20px;\n}\n\n.form-container form {\n    display: flex;\n    flex-direction: column;\n}\n\n.form-container label {\n    margin-bottom: 10px;\n    font-size: 1rem;\n    color: #0e2431;\n}\n\ninput[type=\"text\"],\ninput[type=\"date\"],\nselect {\n    width: 100%;\n    padding: 12px;\n    margin-bottom: 15px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 1rem;\n}\n\ninput[type=\"text\"]:focus,\ninput[type=\"date\"]:focus,\nselect:focus {\n    outline: none;\n    border-color: #0e2431;\n    box-shadow: 0 0 3px rgba(14, 36, 49, 0.5);\n}\n/* Button container to align buttons to the right */\n.button2-container {\n    display: flex;\n    justify-content: space-between; /* Align items to the right */\n    margin-bottom: 20px; /* Add margin to separate from other content */\n  }\n.update-button {\n    background-color: #418ff3;\n    color: #fff;\n    border: none;\n    border-radius: 4px;\n    padding: 10px;\n    font-size: 1rem;\n    cursor: pointer;\n    \n    transition: background-color 0.3s ease;\n}\n.update-button:hover {\n    background-color: #3778cc;\n}\n.delete-button {\n    background-color: #dc3545; /* Red background color */\n    color: #fff;\n    border: none;\n    border-radius: 4px;\n    padding: 10px;\n    font-size: 1rem;\n    cursor: pointer;\n    \n    transition: background-color 0.3s ease;\n}\n\n.delete-button:hover {\n    background-color: #c82333; /* Darker red background color on hover */\n}\n\n\n\n.error-message {\n    background-color: #f8d7da;\n    color: red;\n    margin-bottom: 10px;\n    text-align: center;\n}\n#rackNumber:disabled {\n    opacity: 1; /* Ensures it's fully visible */\n    cursor: default; /* Keeps the default cursor */\n    color: inherit; /* Inherits color from parent */\n    background-color: white; /* Inherits background color from parent */\n    \n    appearance: none; /* Removes default styling */\n  }\n  .update-button:disabled {\n    background-color: #6c757d; /* Gray color for disabled state */\n    color: #ffffff; /* Text color for disabled state */\n    cursor: not-allowed; /* Change cursor to indicate disabled state */\n    opacity: 0.65; /* Optional: Make the button slightly transparent */\n  }\n  /* Overlay that covers the entire viewport and blocks interactions */\n.overlay {\n    position: fixed;          /* Fixed position to cover the entire viewport */\n    top: 0;                  /* Top edge of the viewport */\n    left: 0;                 /* Left edge of the viewport */\n    width: 100vw;            /* Full viewport width */\n    height: 100vh;           /* Full viewport height */\n    background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent black */\n    z-index: 1000;           /* High z-index to appear on top */\n}\n\n/* Popup container styles */\n.confirmation-container {\n    position: fixed;          /* Fixed position to center the popup */\n    top: 50%;                 /* Center vertically */\n    left: 50%;                /* Center horizontally */\n    transform: translate(-50%, -50%); /* Adjust for exact center positioning */\n    background-color: white; /* White background for the popup */\n    color: black;            /* Black text color for contrast */\n    padding: 20px;           /* Padding inside the popup */\n    padding-bottom: 50px;\n    border-radius: 8px;      /* Rounded corners for the popup */\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); /* Shadow for better visibility */\n    z-index: 1001;           /* Ensures the popup appears above the overlay */\n    max-width: 500px;        /* Maximum width for the popup */\n    width: 100%;             /* Full width up to the max-width */\n    box-sizing: border-box; /* Include padding and border in the element's total width and height */\n    text-align: center;      /* Center text inside the popup */\n    display: flex;           /* Flexbox layout for aligning buttons vertically */\n    flex-direction: column;  /* Stack buttons vertically */\n    align-items: center;     /* Center buttons horizontally */\n}\n\n/* Styles for the text and buttons inside the popup */\n.confirmation-container p {\n    margin-bottom: 10px;     /* Space between text and buttons */\n    white-space: pre-line;   /* Handle line breaks in text */\n}\n\n/* General button styles */\n.download-link, .delete-button {\n    margin: 5px;             /* Space between buttons */\n    padding: 10px 20px;      /* Padding inside buttons */\n    border: none;            /* Remove default border */\n    border-radius: 4px;      /* Rounded corners for buttons */\n    color: white;            /* Text color for buttons */\n    cursor: pointer;         /* Pointer cursor on hover */\n    font-size: 16px;         /* Font size for button text */\n    width: 200px;            /* Defined width for buttons */\n    \n}\n\n/* Specific button styles */\n.download-link {\n    background-color: #28a745; /* Green background color */\n}\n\n.download-link:hover {\n    background-color: #218838; /* Darker green background color on hover */\n}\n\n.delete-button {\n    background-color: #dc3545; /* Red background color */\n    \n}\n\n.delete-button:hover {\n    background-color: #c82333; /* Darker red background color on hover */\n   \n}\n\n.cancel1-button {\n    background-color: #007bff; /* Blue background color */\n}\n\n.cancel1-button:hover {\n    background-color: #0056b3; /* Darker blue background color on hover */\n}\n\n/* Position cancel button in the right bottom corner */\n.confirmation-container .cancel1-button {\n    padding: 10px 20px;      /* Padding inside buttons */\n    border: none;            /* Remove default border */\n    border-radius: 4px;      /* Rounded corners for buttons */\n    color: white;            /* Text color for buttons */\n    cursor: pointer;         /* Pointer cursor on hover */\n    font-size: 16px;       \nmargin-top: 5px;\nwidth: 100px; \n  position:absolute;\n  bottom: 10px;\n  right: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
